// extracted by mini-css-extract-plugin
export var circle = "_a1-1";
export var exitConfirmationModal = "_a1-5";
export var iframe = "_a1-0";
export var offline = "_a1-3";
export var online = "_a1-2";
export var workstationSelectError = "_a1-4";